import {Collection} from "vue-mc"
import bookingConfirmedModel from "@/models/bookingConfirmedModel";

export default class bookingConfirmedCollection extends Collection {

    model() {
        return bookingConfirmedModel;
    }

    routes() {
        return {
            fetch: 'interpreter/confirmed'
        }
    }
}
